"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _BasicSendBox = _interopRequireDefault(require("./BasicSendBox"));

var _BasicTranscript = _interopRequireDefault(require("./BasicTranscript"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _concatMiddleware = _interopRequireDefault(require("./Middleware/concatMiddleware"));

var _createCoreMiddleware = _interopRequireDefault(require("./Middleware/Activity/createCoreMiddleware"));

var _createCoreMiddleware2 = _interopRequireDefault(require("./Middleware/Attachment/createCoreMiddleware"));

var _ErrorBox = _interopRequireDefault(require("./ErrorBox"));

var _TypeFocusSink = _interopRequireDefault(require("./Utils/TypeFocusSink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  flexDirection: 'column'
});
var TRANSCRIPT_CSS = (0, _glamor.css)({
  flex: 1
});
var SEND_BOX_CSS = (0, _glamor.css)({
  flexShrink: 0
});

function createActivityRenderer(additionalMiddleware) {
  var activityMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware.default)())({});
  return function () {
    try {
      return activityMiddleware(function (_ref) {
        var activity = _ref.activity;
        return function () {
          console.warn("No activity found for type \"".concat(activity.type, "\"."));
        };
      }).apply(void 0, arguments);
    } catch (err) {
      var FailedRenderActivity = function FailedRenderActivity() {
        return _react.default.createElement(_ErrorBox.default, {
          message: "Failed to render activity"
        }, _react.default.createElement("pre", null, JSON.stringify(err, null, 2)));
      };

      return FailedRenderActivity;
    }
  };
}

function createAttachmentRenderer(additionalMiddleware) {
  var attachmentMiddleware = (0, _concatMiddleware.default)(additionalMiddleware, (0, _createCoreMiddleware2.default)())({});
  return function () {
    try {
      return attachmentMiddleware(function (_ref2) {
        var attachment = _ref2.attachment;
        return _react.default.createElement(_ErrorBox.default, {
          message: "No renderer for this attachment"
        }, _react.default.createElement("pre", null, JSON.stringify(attachment, null, 2)));
      }).apply(void 0, arguments);
    } catch (err) {
      return _react.default.createElement(_ErrorBox.default, {
        message: "Failed to render attachment"
      }, _react.default.createElement("pre", null, JSON.stringify(err, null, 2)));
    }
  };
}

var BasicWebChat =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BasicWebChat, _React$Component);

  function BasicWebChat(props) {
    var _this;

    _classCallCheck(this, BasicWebChat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasicWebChat).call(this, props));
    _this.sendBoxRef = _react.default.createRef();
    _this.state = {
      activityRenderer: createActivityRenderer(props.activityMiddleware),
      attachmentRenderer: createAttachmentRenderer(props.attachmentMiddleware)
    };
    return _this;
  } // TODO: [P2] Move to React 16 APIs


  _createClass(BasicWebChat, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var nextActivityMiddleware = _ref3.activityMiddleware,
          nextAttachmentMiddleware = _ref3.attachmentMiddleware;
      var _this$props = this.props,
          activityMiddleware = _this$props.activityMiddleware,
          attachmentMiddleware = _this$props.attachmentMiddleware;

      if (activityMiddleware !== nextActivityMiddleware || attachmentMiddleware !== nextAttachmentMiddleware) {
        this.setState(function () {
          return {
            activityRenderer: createActivityRenderer(nextActivityMiddleware),
            attachmentRenderer: createAttachmentRenderer(nextAttachmentMiddleware)
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          otherProps = _objectWithoutProperties(_this$props2, ["className"]),
          sendBoxRef = this.sendBoxRef,
          _this$state = this.state,
          activityRenderer = _this$state.activityRenderer,
          attachmentRenderer = _this$state.attachmentRenderer; // TODO: [P2] Implement "scrollToBottom" feature


      return _react.default.createElement(_Composer.default, _extends({
        activityRenderer: activityRenderer,
        attachmentRenderer: attachmentRenderer,
        sendBoxRef: sendBoxRef
      }, otherProps), function (_ref4) {
        var styleSet = _ref4.styleSet;
        return _react.default.createElement(_TypeFocusSink.default, {
          className: (0, _classnames.default)(ROOT_CSS + '', styleSet.root + '', className + ''),
          role: "complementary",
          sendFocusRef: sendBoxRef
        }, _react.default.createElement(_BasicTranscript.default, {
          className: TRANSCRIPT_CSS + ''
        }), !styleSet.options.hideSendBox && _react.default.createElement(_BasicSendBox.default, {
          className: SEND_BOX_CSS + ''
        }));
      });
    }
  }]);

  return BasicWebChat;
}(_react.default.Component);

exports.default = BasicWebChat;
BasicWebChat.defaultProps = {
  activityMiddleware: undefined,
  attachmentMiddleware: undefined,
  className: ''
};
BasicWebChat.propTypes = {
  activityMiddleware: _propTypes.default.func,
  attachmentMiddleware: _propTypes.default.func,
  className: _propTypes.default.string
};